import { render } from "./TSChart.vue?vue&type=template&id=b6cd72fc"
import script from "./TSChart.vue?vue&type=script&lang=js"
export * from "./TSChart.vue?vue&type=script&lang=js"

import "./TSChart.vue?vue&type=style&index=0&id=b6cd72fc&lang=css"

import exportComponent from "C:\\Users\\DD6576\\tourbillon-timescale\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__